/* eslint-disable import/no-anonymous-default-export */

enum ENV_CONFIG_ENUM {
  MATOMO_ID = "matomoID",
  PAYMOB_METHOD = "paymobMethod",
  TIPS_START_PERCENTAGE = "tipsStartPercentage",
  OFFER_SINGLE_POPUP = "featureOffersSinglePopup",
  ORGANIZATION_URL = "organizationUrl",
  FEATURE_WELCOME_POPUP = "featureWelcomePopUp",
}

const envConfig = process.env.NEXT_PUBLIC_ENVIRONMENT
  ? require(`./env/${process.env.NEXT_PUBLIC_ENVIRONMENT}.config.json`)
  : {};

const defaultConfig = require(`./env/default.config.json`);

function getVariable(variable: ENV_CONFIG_ENUM) {
  if (variable in envConfig) {
    return envConfig[variable];
  } else {
    return defaultConfig[variable];
  }
}

export default {
  restaurantId: process.env.NEXT_PUBLIC_RESTAURANT_ID,
  baseUrl: process.env.NEXT_PUBLIC_HOST
    ? process.env.NEXT_PUBLIC_HOST.includes("http")
      ? process.env.NEXT_PUBLIC_HOST
      : "https://" + process.env.NEXT_PUBLIC_HOST
    : "https://api.dev.l.prepits.com",
  apiV1: "v1",
  apiV2: "v2",
  inPipeline: process.env.CI_PIPELINE === "true",
  isLocalHost:
    process.env.NEXT_PUBLIC_HOST &&
    (process.env.NEXT_PUBLIC_HOST.includes("localhost") ||
      process.env.NEXT_PUBLIC_HOST.includes("127.0.0.1")),
  enviroment: process.env.NEXT_PUBLIC_ENVIRONMENT ?? "local",
  backendPollMilliSeconds: process.env.BACKEND_POLL_MILLI_SECONDS
    ? Number(process.env.BACKEND_POLL_MILLI_SECONDS)
    : 5000,
  receiptCheckState: 5000,
  featureFoodCounter: true,
  featureFreeItemSlider: true,
  featureMenuView: true,
  featureWelcomePopUp: getVariable(ENV_CONFIG_ENUM.FEATURE_WELCOME_POPUP),
  featureReorder: true,
  featureLocationDropdown: false,
  paymobMethod: getVariable(ENV_CONFIG_ENUM.PAYMOB_METHOD),
  tipsStartPercentage: getVariable(ENV_CONFIG_ENUM.TIPS_START_PERCENTAGE),
  matomoURL: "https://prepitapp.matomo.cloud/",
  matomoID: getVariable(ENV_CONFIG_ENUM.MATOMO_ID),
  featureDelivery: true,
  featureOffersTab: !(
    process.env.NEXT_PUBLIC_ENVIRONMENT === "prod" ||
    process.env.NEXT_PUBLIC_ENVIRONMENT === "eg"
  ),
  featureOffersSinglePopup: getVariable(ENV_CONFIG_ENUM.OFFER_SINGLE_POPUP),
  featureRestaurantInfoInBuild: !(
    process.env.NEXT_PUBLIC_ENVIRONMENT === "prod" ||
    process.env.NEXT_PUBLIC_ENVIRONMENT === "eg"
  ),
  featureGetColorsInAppJS: false,
  googleMapsId: process.env.NEXT_PUBLIC_GOOGLE_MAPS_ID,
  googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API,
  amplitudeApiKey: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY,
  organizationUrl: getVariable(ENV_CONFIG_ENUM.ORGANIZATION_URL),
  SSLHttpOrHttps:
    (process.env.NEXT_PUBLIC_ENVIRONMENT ?? "local") === "local"
      ? "http"
      : "https",
  defaultLanguage: process.env.DEFAULT_LANGUAGE || "en",
  supportedTranslation: process.env.SUPPORTED_TRANSLATION || "ar",
  peliasApiUrl:
    process.env.NEXT_PUBLIC_PELIAS_API_URL || "https://pilias.eg.prepit.app/v1",
};
